// src/jsx/pages/users/UserManagement.js
import { Button, Modal, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { createUser, deleteUser, getUsers, updateUser } from '../../../lib/userServices';
import UserForm from './UserForm';
import UserTable from './UserTable';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await getUsers();
      setUsers(res.data);
    } catch (err) {
      message.error('Error al cargar los usuarios.');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (data) => {
    try {
      await createUser(data);
      message.success('Usuario creado correctamente.');
      fetchUsers();
      setModalOpen(false);
    } catch (err) {
      message.error('Error al crear usuario.');
    }
  };

  const handleUpdate = async (id, data) => {
    try {
      await updateUser(data);
      message.success('Usuario actualizado.');
      fetchUsers();
      setModalOpen(false);
    } catch (err) {
      message.error('Error al actualizar usuario.');
    }
  };

  const handleDelete = async (data) => {
    try {
      await deleteUser(data);
      message.success('Usuario eliminado.');
      fetchUsers();
    } catch (err) {
      message.error('Error al eliminar usuario.');
    }
  };

  const handleEditClick = (user) => {
    setEditingUser(user);
    setModalOpen(true);
  };

  return (
    <div>
      <h2>Gestión de Usuarios</h2>
      <div style={{marginBottom:"10px", display:"block", textAlign:"right"}}>   <Button type="primary" onClick={() => { setEditingUser(null); setModalOpen(true); }}>
        + Nuevo Usuario
      </Button></div>
   

      <UserTable 
        users={users} 
        loading={loading} 
        onEdit={handleEditClick} 
        onDelete={handleDelete}
      />

      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        destroyOnClose
        title={editingUser ? 'Editar Usuario' : 'Nuevo Usuario'}
      >
        <UserForm
          user={editingUser}
          onSubmit={(data) => {
            editingUser ? handleUpdate(editingUser._id, data) : handleCreate(data);
          }}
        />
      </Modal>
    </div>
  );
};

export default UserManagement;
